import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { SaveUserPreferencesFavoriteSearchRequest } from "@/main/models/request/userPreferencesFavoriteSearchRequest";

export abstract class IUserPreferencesFavoriteSearchApi {
	abstract getUserPreferencesFavoriteSearch<T>(routeUrl: string): Promise<AxiosResponse<Result<T>>>;

	abstract saveUserPreferencesFavoriteSearch(
		request: SaveUserPreferencesFavoriteSearchRequest,
	): Promise<AxiosResponse<Result<void>>>;
}
